var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunVisualization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5C5 7.5 15 7.5 17 15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7440_21781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 9.49967C8.33301 9.9417 8.5086 10.3656 8.82116 10.6782C9.13372 10.9907 9.55765 11.1663 9.99967 11.1663C10.4417 11.1663 10.8656 10.9907 11.1782 10.6782C11.4907 10.3656 11.6663 9.9417 11.6663 9.49967C11.6663 9.05765 11.4907 8.63372 11.1782 8.32116C10.8656 8.0086 10.4417 7.83301 9.99967 7.83301C9.55765 7.83301 9.13372 8.0086 8.82116 8.32116C8.5086 8.63372 8.33301 9.05765 8.33301 9.49967Z",
    fill: "#0A1C22",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.5H6.66667M10 5.75V6.16667M13.3333 9.5H13.75M10 12.8333V13.25M7.33333 6.83333L7.625 7.125M12.6667 6.83333L12.375 7.125M12.375 11.875L12.6667 12.1667M7.625 11.875L7.33333 12.1667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7440_21781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunVisualization);
export default __webpack_public_path__ + "static/media/SunVisualization.965699cbfad89e99535fe95db6f877dd.svg";
export { ForwardRef as ReactComponent };